import {
  React,
  Component,
  axios,
  routes,
} from 'imports/CommonImports';

import {
  FloatingActionButton,
  LinearProgress,
  CircularProgress,
} from 'material-ui';

import {
  FailureColor,
  SecondaryButton,
} from 'imports/DesignImports';

import {
  DownloadIcon,
  DoneIcon,
  CancelIcon,
} from 'imports/IconsImports';

const styles = {
  buttonContainer: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-start',
  },
  floatingButtonContainer: {
    display: 'flex',
    alignItems: 'center',
    marginBottom: '2em',
    fontWeight: '300',
  },
  floatingButton: {
    margin:'0 0.5em 0 1em',
  },
  inputContainer: {
    display: 'flex',
    alignItems: 'flex-end',
  },
}
class FileField extends Component {
  constructor(props){
    super(props);
    this.state = {
      loading: true,
      error: false,
      projectId: props.projectId,
      downloadedFileName: props.downloadedFileName,
      currentFileName: props.currentFileName,
      userPosition: props.userPosition,
      fileStatus: null,
      fileUrl: '',
    }
  }

  componentDidMount(){
    this.getFileDownloadUrl();
  }
  render (){
    if(this.state.loading){
      return(<LinearProgress />)
    }
    else if (this.state.error) {
      return(
        <div>
          <p>No se pudieron encontrar los datos, por favor intenta nuevamente</p>
          <SecondaryButton label="Intenta nuevamente" onClick={this.getFileDownloadUrl}/>
        </div>
      );
    }
    return (
      <div>
        {this.state.userPosition === 'Líder de proyecto' || this.props.projectLeader ?
          <p>Descarga y llena la plantilla. Luego sube el archivo a la plataforma</p> :
          this.state.fileUrl === '' ? <p>Sección vacía. El líder aún no sube el archivo necesario</p> : <p>A continuación puedes descargar el archivo de esta sección</p>
        }
        <div style={styles.buttonContainer}>
          <div style={{display:'flex'}}>
            {this.state.userPosition === 'Líder de proyecto' || this.props.projectLeader &&
              <div style={styles.floatingButtonContainer}>
                <FloatingActionButton mini={true} style={styles.floatingButton}>
                  <DownloadIcon />
                </FloatingActionButton>
                Descargar Plantilla
              </div>
            }
            {this.state.fileUrl !== '' &&
            <div style={styles.floatingButtonContainer}>
              <a href={this.state.fileUrl} download={this.state.downloadedFileName} target="_blank">
                <FloatingActionButton mini={true} style={styles.floatingButton} >
                  <DownloadIcon />
                </FloatingActionButton>
              </a>
            Descargar archivo actual
            </div>
          }
          </div>
          {(this.state.userPosition === 'Líder de proyecto' || this.props.projectLeader) &&
            <div style={styles.inputContainer}>
              <input type="file" id='file' onChange={this.handleSignRequest} onClick={(event)=> {event.target.value = null}} disabled={this.props.disabled}/>
              {this.state.fileStatus}
            </div>
          }
        </div>
      </div>
    );
  }

  handleSignRequest = (event) => {
    this.setState({fileStatus: <CircularProgress size={20} />});
    var file = event.target.files[0];
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.props.token}
    });
    connection.post(routes.signS3(this.props.projectId, file.name, file.type, this.props.uploadType))
    .then((response) => {
      console.log(response);
      this.uploadFile(file, response.data);
    })
    .catch((error) => {
      this.setState({fileStatus: <div style={{display:'flex', alignItems: 'center'}}><CancelIcon color={FailureColor} />{error.response.data.error}</div>});
      console.error(error.response);
    })
  }

  uploadFile = (file, url) => {
    var options = {
      headers: {
        'Content-Type': file.type,
      }
    }

    axios.put(url, file, options)
    .then((response) => {
      this.setState({fileStatus: <DoneIcon />});
      console.log(response);
    })
    .catch((error) => {
      this.setState({fileStatus: <div style={{display:'flex', alignItems: 'center'}}><CancelIcon color={FailureColor} /> No se pudo subir el archivo</div>});
      console.error(error);
    })
  }

  getFileDownloadUrl = () => {
    if(this.state.currentFileName === ''){
      this.setState({
        loading: false,
        error: false,
      })
      return;
    }
    this.setState({loading: true, error:false});
    var fileType = '';
    var connection = axios.create({
      baseURL: routes.host,
      headers: {'Authorization': "Token "+ this.props.token}
    });
    connection.get(routes.signS3(this.state.projectId, this.state.currentFileName, fileType))
    .then((response) => {
      this.setState({
        fileUrl: response.data,
        loading: false,
        error: false,
      })
    })
    .catch((error) => {
      console.error(error);
      this.setState({
        loading: false,
        error: true,
      })
    })
  }
}

export default FileField;



// WEBPACK FOOTER //
// ./src/components/files/FileField.js